import React, { useCallback, useState } from 'react';
import styles from './NoticeDialog.module.css';
import noticeImg from './img/background.png';
import { useQuery } from '@tanstack/react-query';

export default function NoticeDialog() {
  const [style, setStyle] = useState({
    opacity: 1,
  });
  const [vanished, setVanished] = useState(false);
  const handleShow = useCallback(() => {
    setStyle({ opacity: 0 });
    setTimeout(function () {
      setVanished(true);
    }, 600);
  }, []);

  const { isLoading, data: noticeData = { date: null, contents: null, img: null } } = useQuery(
    ['noticeData'],
    async () =>
      fetch('data/notice.json')
        .then((res) => res.json())
        .catch(() => {
          console.error('Check the notice data');
          return { date: null, contents: null, img: null };
        }),
    { staleTime: 1000 * 60 * 10 }
  );

  const hasNoticeImage =
    typeof noticeData.img === 'string' && noticeData.img.trim() !== '';
  const hasNoticeContents =
    typeof noticeData.contents === 'string' && noticeData.contents.trim() !== '';
  const hasNoticeDate =
    typeof noticeData.date === 'string' && noticeData.date.trim() !== '';

  if (isLoading || (!hasNoticeImage && !hasNoticeContents) || vanished) {
    return <></>;
  }

  return (
    <div
      className={styles.container}
      style={style}
      onClick={handleShow}
      onWheel={handleShow}
      onTouchMove={handleShow}
    >
      {hasNoticeImage ? (
        <img
          className={styles['notice-content-img']}
          src={`data/${noticeData.img}`}
          alt={noticeData.date || 'notice image'}
        />
      ) : (
        <>
          <img className={styles['notice-img']} src={noticeImg} alt="notice" />
          {hasNoticeDate && (
            <div className={styles['date-background']}>
              <h3 className={styles.date}>{noticeData.date}</h3>
            </div>
          )}
          {hasNoticeContents && (
            <>
              <div className={styles.contents}>{noticeData.contents}</div>
              <div className={styles.foot} />
            </>
          )}
        </>
      )}
    </div>
  );
}
